import React from 'react';

export const NoMatch = () => (
  <div>
    Page Not Found
  </div>
)